/**
 * walletApi — W1.6
 *
 * Typed openapi-fetch Calls fuer Wallet-Connect-Flow.
 * Endpoints: POST /api/v2/wallets/nonce, POST /api/v2/wallets, DELETE /api/v2/wallets/:id
 */
import apiClient from '../../../lib/api-client'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const client = apiClient as any

export type NonceResponse = {
  nonce: string
  message: string
}

export type ConnectWalletPayload = {
  public_key: string
  signature: string
  message: string
}

export type ConnectedWallet = {
  id: number
  sol_addr: string
  name?: string
  owned: boolean
  hotspot_count: number
}

export type ConnectWalletErrorBody = {
  code?: string
  message?: string
}

export async function requestNonce(
  publicKey: string,
): Promise<{ data?: NonceResponse; error?: unknown; response: Response }> {
  return client.POST('/api/v2/wallets/nonce', {
    body: { public_key: publicKey },
  })
}

export async function connectWallet(
  payload: ConnectWalletPayload,
): Promise<{ data?: ConnectedWallet; error?: ConnectWalletErrorBody; response: Response }> {
  return client.POST('/api/v2/wallets', { body: payload })
}

export async function disconnectWallet(
  id: number,
): Promise<{ error?: unknown; response: Response }> {
  return client.DELETE('/api/v2/wallets/{id}', { params: { path: { id } } })
}

// F-035: Watched Wallets — Add wallet without ownership verification
export async function addWatchedWallet(
  publicKey: string,
): Promise<{ data?: ConnectedWallet; error?: ConnectWalletErrorBody; response: Response }> {
  return client.POST('/api/v2/wallets/watch', { body: { public_key: publicKey } })
}

// Welle 4b / WP-B: Owned-Wallet ohne Signatur (v1-Paritaet, siehe WP-A-Auftrag).
// POST /api/v2/wallets akzeptiert additiv { address, owned: true, name } OHNE
// Nonce/Signatur-Flow — parallel zum bestehenden Ed25519-Signatur-Pfad
// (connectWallet oben, weiterhin unveraendert fuer den vollen Signing-Flow).
// Der Kontrakt ist zum Zeitpunkt dieser Aenderung noch nicht additiv nach
// api-types/openapi.yaml nachgezogen (WP-A/Backend laeuft parallel) — daher
// wie addWatchedWallet ueber den gecasteten `client` statt typisiert.
export async function addOwnedWallet(
  address: string,
  name?: string,
): Promise<{ data?: ConnectedWallet; error?: ConnectWalletErrorBody; response: Response }> {
  return client.POST('/api/v2/wallets', { body: { address, owned: true, name } })
}

// F-035: Fetch only watched wallets (owned=false)
export async function fetchWatchedWallets(): Promise<{
  data?: ConnectedWallet[]
  error?: unknown
  response: Response
}> {
  return client.GET('/api/v2/wallets', { params: { query: { owned: false } } })
}

// watched-wallets: Notify-on-change Toggle. PATCH /api/v2/wallets/{id} ist
// real im Contract (api-types/index.d.ts, updateApiV2Wallet) — kein `as any`
// noetig, typed ueber apiClient direkt statt dem gecasteten `client`.
export async function setWalletNotify(
  id: number,
  notify: boolean,
): Promise<{ error?: unknown; response: Response }> {
  return apiClient.PATCH('/api/v2/wallets/{id}', {
    params: { path: { id } },
    body: { wallet: { notify } },
  })
}
